import { PropsWithChildren } from 'react'
import Styles from 'components/FirstTimeExperienceModal/components/Footer/Footer.module.scss'
import cx from 'classnames'
import { StickyFooterProps } from 'providers/StickyFooterProvider/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const StickyFooter = ({ children, isFloating = false }: PropsWithChildren<StickyFooterProps>) => {
  const { isMobile } = useResponsiveDesign()
  return <div className={cx(Styles.container, { [Styles.floating]: isFloating && !isMobile })}>{children}</div>
}

export const Footer = ({ children }: PropsWithChildren) => <div className={Styles.footer}>{children}</div>

export const FooterButtons = ({ children }: PropsWithChildren) => <div className={Styles.buttons}>{children}</div>
